import {sidebar} from './Sidebar/sl'

export const layout = {
  ...sidebar,
}
